import React from "react";
import logger from "logger";
import BubbleTimer from "../BubbleTimer";
import { getAbbreviatedNumber } from "Utils/Common";
import { StringValue } from "TaskHistory/Tasklet/Tasklets/StringValue";
import TaskletCard from "TaskHistory/Tasklet/Tasklets/TaskletCard";
import CardContent from "@material-ui/core/CardContent";

export default function(props) {
  const { accountdetail } = props;
  return (
    <TaskletCard>
      <CardContent>
        <StringValue
          label={"Boxed Might"}
          value={getAbbreviatedNumber(accountdetail.boxedmight)}
        />
        <StringValue
          label={"Boxed Wall Might"}
          value={getAbbreviatedNumber(accountdetail.boxedwallmight)}
        />
        <StringValue label={"Boxed Crowns"} value={accountdetail.boxedcrowns} />
        <StringValue label={"Boxed Mith"} value={accountdetail.boxedmith} />
        <StringValue label={"Tauriels"} value={accountdetail.tauriels} />
        <StringValue label={"Thorins"} value={accountdetail.thorins} />
        <StringValue label={"Gandalfs"} value={accountdetail.gandalfs} />
        <StringValue label={"Bards"} value={accountdetail.bards} />
        <StringValue label={"Legolas"} value={accountdetail.legolas} />
        <StringValue
          label={"Elite Stamina Refill"}
          value={accountdetail.estams}
        />
        <StringValue label={"Stamina Refill"} value={accountdetail.stams} />
        <StringValue label={"5 Dwarf Picks"} value={accountdetail.dwarfpicks} />
        <StringValue label={"Kabam Id"} value={accountdetail.kabamid} />
        <StringValue
          label={"Bubbled Status"}
          value={
            <BubbleTimer instanceMillis={accountdetail.bubbleendtimemillis} />
          }
        />
      </CardContent>
    </TaskletCard>
  );
}
